import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CodeState {
  id: string | null;
}

const initialState: CodeState = {
  id: null,
};

const codeSlice = createSlice({
  name: 'code',
  initialState,
  reducers: {
    setCodeId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    clearCodeId: state => {
      state.id = null;
    },
  },
});

export const { setCodeId, clearCodeId } = codeSlice.actions;
export default codeSlice.reducer;
